module.exports = __webpack_public_path__ + "img/student4.66e91dbc.png";